module.exports = __webpack_public_path__ + "static/img/58.c997e24.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/58.png
// module id = ldeG
// module chunks = 1